// extracted by mini-css-extract-plugin
export var lg = "_2e-4";
export var md = "_2e-3";
export var sm = "_2e-2";
export var xs = "_2e-1";
export var xxs = "_2e-0";